import { createFileRoute } from "@tanstack/react-router";
import { BrancherIndexPage, brancherHead } from "@/pages/BrancherIndexPage";

export const Route = createFileRoute("/en/industries/")({
  head: () => brancherHead("en"),
  component: () => <BrancherIndexPage locale="en" />,
});
